import { BREAKPOINTS } from '@skyscanner-internal/backpack-web/bpk-component-breakpoint';

import logoLarge from './logo-large.svg';
import logoMedium from './logo-medium.svg';
import logoSmall from './logo-small.svg';

type Variant = 'hero' | 'footer';

type HeroVariant = { type: 'two-tier'; mobileSrc: string; desktopSrc: string; breakpoint: string };
type FooterVariant = {
  type: 'three-tier';
  smallSrc: string;
  mediumSrc: string;
  largeSrc: string;
  tabletBreakpoint: string;
  desktopBreakpoint: string;
};

const VARIANTS: Record<Variant, HeroVariant | FooterVariant> = {
  hero: {
    type: 'two-tier',
    mobileSrc: logoSmall,
    desktopSrc: logoMedium,
    breakpoint: BREAKPOINTS.ABOVE_MOBILE,
  },
  footer: {
    type: 'three-tier',
    smallSrc: logoSmall,
    mediumSrc: logoMedium,
    largeSrc: logoLarge,
    tabletBreakpoint: BREAKPOINTS.ABOVE_MOBILE,
    desktopBreakpoint: BREAKPOINTS.ABOVE_TABLET,
  },
};

type Props = { variant: Variant };

export const TravelBetaLogo = ({ variant }: Props) => {
  const config = VARIANTS[variant];

  if (config.type === 'three-tier') {
    return (
      <picture>
        <source media={config.desktopBreakpoint} srcSet={config.largeSrc} />
        <source media={config.tabletBreakpoint} srcSet={config.mediumSrc} />
        <img src={config.smallSrc} alt="" />
      </picture>
    );
  }

  return (
    <picture>
      <source media={config.breakpoint} srcSet={config.desktopSrc} />
      <img src={config.mobileSrc} alt="" />
    </picture>
  );
};
